var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSecondDisplay = function SvgSecondDisplay(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 48 48"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.5 11.5v12H17V26H5a1 1 0 0 1-1-1V10a1 1 0 0 1 1-1h23a1 1 0 0 1 1 1v6h-2.5v-4.5zM39 37H24v2h15zM9 28h8v2H9zm11-10a1 1 0 0 0-1 1v15a1 1 0 0 0 1 1h23a1 1 0 0 0 1-1V19a1 1 0 0 0-1-1zm1.5 2.5h20v12h-20z"
  })));
};
export default SvgSecondDisplay;